import { SignIn } from "@clerk/clerk-react";
import { useTranslation } from "react-i18next";
import { AuthLayout } from "@/components/AuthLayout";

export default function SignInPage() {
  const { t } = useTranslation();

  return (
    <AuthLayout
      title={t('auth.welcomeBack')}
      subtitle={t('auth.signInToPost')}
    >
      <SignIn 
        routing="path" 
        path="/sign-in" 
        signUpUrl="/sign-up"
        afterSignInUrl="/dashboard"
        appearance={{
          layout: {
            socialButtonsPlacement: "top",
            socialButtonsVariant: "blockButton",
          },
          elements: {
            rootBox: "w-full",
            card: "shadow-none border-none bg-transparent w-full p-0 gap-6",
            header: "hidden", // We use our own header in AuthLayout
            formButtonPrimary: 
              "bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 rounded-md transition-colors",
            socialButtonsBlockButton: 
              "border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 rounded-md transition-colors text-foreground",
            socialButtonsBlockButtonText: "font-medium",
            dividerLine: "bg-border",
            dividerText: "text-muted-foreground",
            formFieldLabel: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-foreground mb-2",
            formFieldInput: 
              "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            footerActionLink: "text-primary hover:text-primary/90 underline-offset-4 hover:underline",
            footer: {
              background: "transparent"
            }
          }
        }}
      />
    </AuthLayout>
  );
}

